// @flow
import Order from '../pages/Order'

import $ from 'jquery'

import Translation from '../i18n/Translation'

export default class RequestDialog {

  static init () {

    let $closeBtn = $('#request-dialog .close-dialog') 
    $closeBtn.click(()=> {
      $('#request-dialog').addClass('hidden')
      //setTimeout ( ()=> {
        //window.location = "/"
      //}, 300)
    })

    let $noBtn = $('#request_no') 
    $noBtn.click(()=> {
      $('#request-dialog').addClass('hidden')
    })

    let $yesBtn = $('#request_yes') 
    $yesBtn.click(()=> {
      $('#request-dialog').addClass('hidden')
      Order._submitTerminationFunction()
    })

    //if (showFinishDialog) {
      //$('#finish-dialog').removeClass('hidden')
      //if (showButton == true) {
        //let $btn = $('#finish-dialog .close-dialog') 
        //$btn.removeClass('hidden')
        //$btn.click(()=> {
          //localStorage.setItem('vol_order_completed', 'true')
          //localStorage.removeItem('vol_orders_finish_status')

          //setTimeout ( ()=> {
            //window.location = "/"
          //}, 300)

        //})
      //}
      //$(document.body).addClass('fade')

      //const success = showFinishDialog === 'success' ? 'success' : 'failed'

      //$('#request-dialog .dialog-title').html(Translation.getText(`order_dialog_message_${success}`))
      //$('#request-dialog .dialog-description').html(Translation.getText(`order_dialog_description_${success}`))
      //$('#request-dialog .dialog-icon').addClass('hidden')
      //$(`#request-dialog #icon-${success}`).removeClass('hidden')
  }
  static show() {

    //$(document.body).addClass('fade')
    $('#request-dialog').removeClass('hidden')

  }
}
